











































































































































































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";

import {
  INoteValue,
  NoteValue,
  IInstrumentSettings,
  PianoData
} from "piano-chart";
import { NoteNameBehavior } from "piano-chart/typings/InstrumentSettings";
import { PCKeyboard } from "@/classes/input/PCKeyboard";
import { MIDIKeyboard, MidiInputInfo } from "@/classes/input/MIDIKeyboard";
import { ScaleHelper, Mode } from "piano-chart";

import InstrumentContainer from "@/components/InstrumentContainer.vue";
import TipBlock from "@/components/TipBlock.vue";
import PromoBlock from "@/components/PromoBlock.vue";
import { Input } from "webmidi";

import { mdiMidi, mdiTwitter, mdiFacebook } from "@mdi/js";
import { Synth } from "../classes/Synth";

@Component({
  components: {
    "instrument-container": InstrumentContainer,
    "tip-block": TipBlock,
    "promo-block": PromoBlock
  }
})
export default class PianoShowMain extends Vue {
  midiIconPath = mdiMidi;
  twitterIconPath = mdiTwitter;
  facebookIconPath = mdiFacebook;

  tipsVisible = true;

  currentOctave = 3;

  readonly keyboardSizes = [0, 25, 49, 61, 88];
  actualKeyboardSize = 0;
  keyboardSize = 0;

  readonly noteNameModes = [
    { value: "always", text: "Always" },
    { value: "onpress", text: "When pressed" },
    { value: "onhighlight", text: "When highlighted" },
    { value: "never", text: "Never" }
  ];

  toggleMode = false;
  pressedKeys: NoteValue[] = [];

  highlightScale = false;
  readonly keys = [
    { value: "C", text: "C" },
    { value: "C#", text: "C#" },
    { value: "Db", text: "Db" },
    { value: "D", text: "D" },
    { value: "D#", text: "D#" },
    { value: "Eb", text: "Eb" },
    { value: "E", text: "E" },
    { value: "F", text: "F" },
    { value: "F#", text: "F#" },
    { value: "Gb", text: "Gb" },
    { value: "G", text: "G" },
    { value: "G#", text: "G#" },
    { value: "Ab", text: "Ab" },
    { value: "A", text: "A" },
    { value: "A#", text: "A#" },
    { value: "Bb", text: "Bb" },
    { value: "B", text: "B" }
  ];
  keyNote = "C";

  readonly modes = [
    { value: "major", text: "Major" },
    { value: "minor", text: "Natural Minor" },
    { value: "dorian", text: "Dorian" },
    { value: "phrygian", text: "Phrygian" },
    { value: "lydian", text: "Lydian" },
    { value: "mixolydian", text: "Mixolydian" },
    { value: "locrian", text: "Locrian" },
    { value: "majorpentatonic", text: "Major Pentatonic" },
    { value: "minorpentatonic", text: "Minor Pentatonic" },
    { value: "harmonicminor", text: "Harmonic Minor" },
    { value: "melodicminor", text: "Melodic Minor" }
  ];
  scaleMode = "major";

  readonly keyPressStyles = [
    { value: "subtle", text: "Subtle gradient" },
    { value: "vivid", text: "Vivid orange fill" }
  ];

  instrumentSettings: IInstrumentSettings = {
    startOctave: 1,
    startNote: "C",
    endOctave: 5,
    endNote: "C",
    showNoteNames: "onpress",
    // highlightedNotes: ["C", "C#3", "D#3", "FX", { note: "E", octave: 3 }],
    // specialHighlightedNotes: [{ note: "C" }],
    showOctaveNumbers: true,
    keyPressStyle: "vivid",
    vividKeyPressColor: "#ffb820"
  };
  activeInstrumentSettings: IInstrumentSettings = Object.assign(
    {},
    this.instrumentSettings
  );

  midiInputs: MidiInputInfo[] = [];
  midiInputId = "";

  isMidiSettingsOpen = false;
  isSettingsOpen = false;
  isShareOpen = false;

  isSoundOn = true;

  isScreenshotOpen = false;
  showScreenshotSignature = true;
  screenshotDataUrl = "";

  private get shareUrl(): string {
    let result = "";

    if (this.pressedKeys.length > 0) {
      let keys = "";
      this.pressedKeys.forEach((note, index) => {
        keys += `${index > 0 ? "," : ""}${note.toString()}`;
      });
      result += `&keys=${encodeURIComponent(keys)}`;
    }

    if (this.highlightScale) {
      result += `&hscale=${encodeURIComponent(
        this.keyNote.toString() + ":" + this.scaleMode
      )}`;
    }

    if (this.keyboardSize !== 0) {
      result += `&size=${this.keyboardSizes[this.keyboardSize]}`;
    }

    if (this.currentOctave !== 4) {
      result += `&octave=${this.currentOctave}`;
    }

    if (
      this.instrumentSettings.showNoteNames !== undefined &&
      this.instrumentSettings.showNoteNames !== "onpress"
    ) {
      result += `&names=${this.instrumentSettings.showNoteNames}`;
    }

    if (result.length > 0) {
      result = "?" + result.substr(1);
    }

    return "https://pianoshow.me/" + result;
  }

  mounted() {
    if (this.keyboardSize === 0) {
      this.adjustKeyboardSize();
      this.activateSettings();
    }
    this.addKeyboardListeners();
    this.addMidiListeners();
    this.parseQueryString();

    Synth.init();
  }

  beforeDestroy() {
    this.removeKeyboardListeners();
    this.removeMidiListeners();
  }

  parseQueryString() {
    // need to apply this **after** the settings are set
    const pressedNotes: NoteValue[] = [];

    const url = new URL(window.location.href);
    if (url.searchParams !== undefined) {
      url.searchParams.forEach((value, key) => {
        switch (key) {
          case "keys": {
            const stringNotes = value.split(",");
            stringNotes.forEach(note => {
              pressedNotes.push(new NoteValue(note));
            });

            if (this.pressedKeys.length > 0) {
              // switch toggle mode on to show pressed keys
              this.toggleMode = true;
            }
            break;
          }
          case "hscale": {
            const scaleParts = value.split(":");
            if (scaleParts !== undefined && scaleParts.length === 2) {
              this.highlightScale = true;
              this.keyNote = scaleParts[0];
              this.scaleMode = scaleParts[1];
            }
            break;
          }
          case "size": {
            this.keyboardSize = this.keyboardSizes.indexOf(
              Number.parseInt(value)
            );
            break;
          }
          case "octave": {
            this.currentOctave = Number.parseInt(value);
            break;
          }
          case "names": {
            this.instrumentSettings.showNoteNames = value as NoteNameBehavior;
            break;
          }
        }
      });

      this.applySettings();
      // workaround: key presses are somehow removed when applying the settings
      this.$nextTick(() => this.pressedKeys.push(...pressedNotes));
    }
  }

  activateSettings() {
    this.activeInstrumentSettings = Object.assign({}, this.instrumentSettings);
  }

  applySettings() {
    this.activateSettings();
    this.isSettingsOpen = false;
  }

  addPressedNote(note: INoteValue) {
    const newNote = new NoteValue(note);
    const newBaseNote = newNote.baseNote;
    if (
      this.pressedKeys.findIndex(n => {
        const pBaseNote = n.baseNote;
        return (
          newBaseNote.note === pBaseNote.note &&
          newBaseNote.accidental === pBaseNote.accidental &&
          newBaseNote.octave === pBaseNote.octave
        );
      }) < 0
    ) {
      this.pressedKeys.push(newNote);

      if (this.isSoundOn) {
        if (this.toggleMode) {
          Synth.playNote(newNote.toString());
        } else {
          Synth.noteDown(newNote.toString());
        }
      }
    }
  }

  removePressedNote(note: INoteValue) {
    const newNote = new NoteValue(note);
    const newBaseNote = newNote.baseNote;
    const noteIndex = this.pressedKeys.findIndex(n => {
      const pBaseNote = n.baseNote;
      return (
        newBaseNote.note === pBaseNote.note &&
        newBaseNote.accidental === pBaseNote.accidental &&
        newBaseNote.octave === pBaseNote.octave
      );
    });

    if (noteIndex > -1) {
      this.pressedKeys.splice(noteIndex, 1);
      if (this.isSoundOn && !this.toggleMode) {
        Synth.noteUp(newNote.toString());
      }
    }
  }

  togglePressedNote(note: INoteValue) {
    const newNote = new NoteValue(note);
    const newBaseNote = newNote.baseNote;
    const noteIndex = this.pressedKeys.findIndex(n => {
      const pBaseNote = n.baseNote;
      return (
        newBaseNote.note === pBaseNote.note &&
        newBaseNote.accidental === pBaseNote.accidental &&
        newBaseNote.octave === pBaseNote.octave
      );
    });

    if (noteIndex > -1) {
      this.removePressedNote(note);
    } else {
      this.addPressedNote(note);
    }
  }

  addKeyboardListeners() {
    window.addEventListener("keydown", this.pcKeyDown);
    window.addEventListener("keyup", this.pcKeyUp);
  }

  removeKeyboardListeners() {
    window.removeEventListener("keydown", this.pcKeyDown);
    window.removeEventListener("keyup", this.pcKeyUp);
  }

  handleNoteDown(note?: INoteValue) {
    if (note) {
      if (this.toggleMode) {
        this.togglePressedNote(note);
      } else {
        this.addPressedNote(note);
      }
    }
  }

  handleNoteUp(note?: INoteValue) {
    if (note) {
      if (!this.toggleMode) {
        this.removePressedNote(note);
      }
    }
  }

  pcKeyDown(ev: KeyboardEvent) {
    const noteDown = PCKeyboard.noteFromKey(ev.keyCode, this.currentOctave);
    this.handleNoteDown(noteDown);
  }

  pcKeyUp(ev: KeyboardEvent) {
    const noteUp = PCKeyboard.noteFromKey(ev.keyCode, this.currentOctave);
    this.handleNoteUp(noteUp);
  }

  setCurrentMidiInput(inputId: string) {
    MIDIKeyboard.releaseCurrent();
    MIDIKeyboard.setCurrentInput(inputId);
    MIDIKeyboard.addNoteOnListener(note => {
      this.handleNoteDown(note);
    });
    MIDIKeyboard.addNoteOffListener(note => {
      this.handleNoteUp(note);
    });
  }

  handleMidiInit(inputs?: Input[], err?: Error) {
    if (err) {
      console.log("Error initializing WebMidi.", err);
    } else if (inputs !== undefined) {
      this.midiInputs.splice(0);
      this.midiInputs.push({ id: "", name: "No MIDI Input" });
      if (inputs.length > 0) {
        this.midiInputs.push(...inputs);
        this.midiInputId = this.midiInputs[1].id;
      }
    }
  }

  addMidiListeners() {
    MIDIKeyboard.releaseCurrent();
    MIDIKeyboard.init(this.handleMidiInit);
  }
  removeMidiListeners() {
    MIDIKeyboard.releaseCurrent();
  }
  resetMidi() {
    MIDIKeyboard.shutdown();
    this.addMidiListeners();
  }

  currentOctaveUp() {
    this.currentOctave++;
    this.adjustKeyboardSize();
  }

  currentOctaveDown() {
    this.currentOctave--;
    this.adjustKeyboardSize();
  }

  getOptimalKeyboardSize(): number {
    const availableWidth = (this.$refs.instrumentWrapper as HTMLElement)
        .clientWidth,
      availableHeight = (this.$refs.instrumentWrapper as HTMLElement)
        .clientHeight,
      minKeyWidth = 50;

    let result = 1;
    for (let i = 1; i < this.keyboardSizes.length; i++) {
      const whiteKeysNo = (this.keyboardSizes[i] / 12) * 7;
      const maxKeyWidth = availableWidth / whiteKeysNo;
      let keyWidth = maxKeyWidth;
      if (PianoData.WHITE_KEY_RATIO * maxKeyWidth > availableHeight) {
        keyWidth = availableHeight / PianoData.WHITE_KEY_RATIO;
      }
      if (keyWidth > minKeyWidth) {
        result = i;
      }
    }

    return result;
  }

  @Watch("keyboardSize")
  adjustKeyboardSize() {
    const size =
      this.keyboardSize > 0 ? this.keyboardSize : this.getOptimalKeyboardSize();
    switch (size) {
      case 1: {
        this.instrumentSettings.startNote = "C";
        this.instrumentSettings.startOctave = this.currentOctave - 1;
        this.instrumentSettings.endNote = "C";
        this.instrumentSettings.endOctave = this.currentOctave + 1;
        break;
      }
      case 2: {
        this.instrumentSettings.startNote = "C";
        this.instrumentSettings.startOctave = this.currentOctave - 2;
        this.instrumentSettings.endNote = "C";
        this.instrumentSettings.endOctave = this.currentOctave + 2;
        break;
      }
      case 3: {
        this.instrumentSettings.startNote = "C";
        this.instrumentSettings.startOctave = this.currentOctave - 2;
        this.instrumentSettings.endNote = "C";
        this.instrumentSettings.endOctave = this.currentOctave + 3;
        break;
      }
      case 4: {
        this.instrumentSettings.startNote = "A";
        this.instrumentSettings.startOctave = this.currentOctave - 4;
        this.instrumentSettings.endNote = "C";
        this.instrumentSettings.endOctave = this.currentOctave + 4;
        break;
      }
    }
    this.actualKeyboardSize = size;
  }

  adjustKeyboardOnResize() {
    const currentSize = this.actualKeyboardSize;
    this.adjustKeyboardSize();
    if (currentSize !== this.actualKeyboardSize) {
      this.activateSettings();
    }
  }

  @Watch("midiInputId")
  changeMidiInput() {
    this.setCurrentMidiInput(this.midiInputId);
  }

  @Watch("keyNote")
  @Watch("scaleMode")
  @Watch("highlightScale")
  highlightNotes() {
    if (this.highlightScale) {
      const scale = ScaleHelper.getScale(
        new NoteValue(this.keyNote),
        this.scaleMode as Mode
      );
      this.instrumentSettings.highlightedNotes = scale.notes;
      this.instrumentSettings.specialHighlightedNotes = [scale.root];
    } else {
      this.instrumentSettings.highlightedNotes = [];
      this.instrumentSettings.specialHighlightedNotes = [];
    }
    this.applySettings();
  }

  copyShareUrl() {
    navigator.clipboard.writeText(this.shareUrl);
  }

  @Watch("toggleMode")
  clearAllPressedNotes() {
    if (!this.toggleMode) {
      this.pressedKeys.splice(0);
    }
  }

  @Watch("showScreenshotSignature")
  takeScreenshot() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (this.$refs.instrument as any).takeScreenshot(
      this.showScreenshotSignature ? "made with PianoShow.me" : undefined
    );
  }
  showScreenshot(dataUrl: string) {
    this.screenshotDataUrl = dataUrl;
    this.isScreenshotOpen = true;
  }
}
